"use client";
import { useMemo } from "react";
import { motion } from "framer-motion";
import CTA from "@/components/CTA";
import Google from "@/assets/Google_Play.png";
import Apple from "@/assets/App_Store.png";
import { useLocale } from "@/i18n/provider";
import { localizePath } from "@/i18n/pathnames";
import { getScrollAnimation } from "@/utils/getScrollAnimation";

export const BlackCTA = ({
  page,
  ctaTitle,
  ctaDescription,
  ctaUrl,
  buttonText,
}: {
  page: string;
  ctaTitle: string;
  ctaDescription: string;
  ctaUrl: string;
  buttonText: string;
}) => {
  const scrollAnimation = useMemo(() => getScrollAnimation(), []);
  const locale = useLocale();

  return (
    <div className="bg-[#0A0D14] ">
      <div className="container !px-0 py-20">
        <CTA
          title={ctaTitle}
          text={ctaDescription}
          buttonText={buttonText}
          onClick={() => {
            window.open(localizePath(ctaUrl, locale), "_blank");
          }}
        />
      </div>

      <div className="flex justify-center items-center gap-4 pt-5 pb-10">
        <button
          onClick={() =>
            window.open(
              "https://play.google.com/store/apps/details?id=com.ajobox.app&pcampaignid=web_share",
              "_blank"
            )
          }
        >
          <motion.img
            variants={scrollAnimation}
            src={Google.src}
            alt="Google Store"
            width={200}
          />
        </button>
        <button
          onClick={() =>
            window.open(
              "https://apps.apple.com/us/app/cliqbox/id1607163500",
              "_blank"
            )
          }
        >
          <motion.img
            variants={scrollAnimation}
            src={Apple.src}
            alt="Apple Store"
            width={200}
          />
        </button>
      </div>
    </div>
  );
};
